import React from 'react';
import { createRoot } from 'react-dom/client';
import './scss/style.scss';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configureStore from './store';
import NavRouter from './components/Router';
import Footer from './components/Footer/footer';

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore()}>
    <NavRouter />
    <Footer />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
